<template>
  <section>
    <!-- Testimonials Section -->
<div class="space"></div>  
          <div class="container">
            <div class="text-center">
            <div class="row">
              <div class="container">
              <div id=testimonials>
              <div class="space"></div>
              <div class="col-md-8 col-md-offset-2 shadow-on-hov" style="background:#fff">
                <div style="margin:-50px;">
                  <i class="fa big-fa fa-quote-left"></i>
                  <p style="font-size:30px;font-weight:700">What our Clients think</p>
                  <br>
                </div>
                <div class="space"></div>
                <carousel paginationActiveColor="#334B75" :per-page="1" :mouse-drag="true" :autoplay="true" :autoplayTimeout="5000" :loop="true">
                  <slide v-for="(testimonial,t) in company" :key="t">
                    <div class="item">
                      <p v-html="testimonial.content.rendered"></p>
                      <div class="author">- <span v-html="testimonial.title.rendered"></span></div>
                    </div>
                  </slide>
                </carousel>
              </div>
            </div>
          </div>
        </div>
        <div class="space"></div>
</div></div>
  </section>
</template>

<script>
  const axios = require("axios")
  import {
    Carousel,
    Slide
  } from "vue-carousel";
  export default {
    components: {
      Carousel,
      Slide,
    },
    data() {
      return {
        company: []
      }
    },
    mounted() {
      this.getTestimonials();
    },
    methods: {
      async getTestimonials() {
        var res = await axios({
          method: "get",
          url: "https://compu-info-1abfbc.ingress-comporellon.easywp.com/wp-json/wp/v2/posts?categories=3"
        })
        this.company = res.data
        console.log(this.company)
      }
    }
  };
  

</script>

<style scoped>
  .author {
    color: #bfbfbf;
    text-align: right;
  }

</style>


